<!-- <ng-template #c let-dp>
	<div class="p-2">
		<div class="btn-group d-flex justify-content-end mb-2" role="group">
			<button type="button" class="btn btn-sm btn-outline-primary" (click)="navigate(dp, -1);">Prev</button>
			<button type="button" class="btn btn-sm btn-outline-primary" (click)="today(dp)">Today</button>
			<button type="button" class="btn btn-sm btn-outline-primary" (click)="navigate(dp, 1)">Next</button>
		</div>
		<div class="custom-month-grid">
			<div *ngFor="let month of dp.state.months">
				<div class="text-primary p-1 fw-bold">{{ dp.i18n.getMonthShortName(month.month) }} {{ month.year }}</div>
				<ngb-datepicker-month class="border rounded" [month]="month"></ngb-datepicker-month>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #t let-date
  let-currentMonth="currentMonth"
  let-selected="selected"
  let-disabled="disabled"
  let-focused="focused"
>
  <span
    class="custom-day"
    [class.focused]="focused"
    [class.bg-primary]="selected"
    [class.hidden]="date.month !== currentMonth"
    [class.text-muted]="disabled"  >
    {{date.day}}
  </span>
</ng-template>

<div class="d-inline-block mb-3">
	<ngb-datepicker
  class="px-3 pt-1 pb-3"
  [displayMonths]="4"
  [contentTemplate]="c"
  outsideDays="hidden"
  [weekdays]="false"
  navigation="none"
	>
	</ngb-datepicker>
</div> -->
<form class="flex flex-column align-content-center" [formGroup]="bookActivityForm">
  <mat-form-field class="example-full-width">
    <mat-label>Choose a date</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="dateSelectionCtrl" [matDatepickerFilter]="unavailableFilter">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker touchUi #picker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Slots Needed - {{currentSlotPrice | currency}}</mat-label>
    <input matInput type="number" formControlName="slotsSelectorCtrl" min="0" [max]="currentSlotMax" (change)="takeSlot()">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Slots</mat-label>
    <input matInput type="number" formControlName="slotsTotalLeftCtrl">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Total</mat-label>
    <span matIconPrefix><mat-icon aria-hidden="false" aria-label="currency" fontIcon="attach_money"></mat-icon>
    </span>
    <input matInput [disabled] type="" formControlName="totalCostCtrl">
  </mat-form-field>
  <div class="flex justify-content-center" #tooltip="matTooltip" matTooltip="Login to book an activity" [matTooltipDisabled]="signedIn">
    <button mat-raised-button  color="primary" [disabled]="!signedIn" (click)="bookActivity()">Book Activity</button>
  </div>
</form>